/* @jsx h */
import { useMenu } from "@app/vue/providers/Menu";
import { getRestaurantImageURL } from "@lemmonhq/blogic";
import { defineComponent, ref, h } from "vue";

export const ShopHeaderMain = defineComponent({
  name: "NavBarMain",
  setup(props) {
    const navbarHeight = ref(300);
    const { shop } = useMenu();
    return () => {
      if (!shop.value.welcome_screen_image) return null;
      return (
        <div class="menu-navbar " style={{ height: `${navbarHeight.value}px` }}>
          <div class="menu-navbar-content h-full ">
            <div class="h-full inset-0 flex flex-col pt-[0px] pb-0">
              <div class="flex flex-1 justify-center items-center ">
                <div
                  style={`background-image: url("${getRestaurantImageURL(
                    shop.value,
                  )}");`}
                  class="flex-1 bg-no-repeat bg-cover bg-center h-full"
                ></div>
              </div>
            </div>
          </div>
        </div>
      );
    };
  },
});
